module.exports = __webpack_public_path__ + "static/media/chevron-left-big-icon.8daf5ae3.svg";